import React from 'react';
import { MENU_ENTRIES } from '../constants';

import ZipUploadProcess from './zip-upload-process';

const UploadingZipToPortal = ({ onSectionChange }) => (
  <div data-subsection={MENU_ENTRIES.uploadingZipToPortal}>
    <h3>
      STEP 6: UPLOADING THE ZIP FILE TO THE PORTAL
    </h3>
    <p>
      Once your zip file is ready, it can be uploaded to the portal. To upload it manually, follow the steps below. To
      upload it <i>via</i> an automated API, please refer to section: <a
      onClick={e => onSectionChange(MENU_ENTRIES.apiTechnicalDetails)}>API technical details for automated uploads</a>.
    </p>
    <p className="pt-callout pt-intent-warning pt-icon-info-sign">
      <strong>Important:</strong> You MUST have an API key to proceed (see section: <a
      onClick={e => onSectionChange(MENU_ENTRIES.apiKey)}>API key</a>).
    </p>
    <br/>
    <ZipUploadProcess/>
  </div>
);

export default UploadingZipToPortal;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/uploading-zip-to-portal/index.js